import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { createCustomElement } from '@angular/elements';
import { CareerComponent } from './app/career/career/career.component';
import { AppHeaderComponent } from './app/app-header/app-header.component';
import { AppFooterComponent } from './app/app-footer/app-footer.component';
import { NotFoundComponent } from './app/not-found/not-found.component';
import { SignLanguageComponent } from './app/sign-language/sign-language.component';
import { InternalErrorComponent } from './app/internal-error/internal-error.component';

bootstrapApplication(AppComponent, appConfig)
  .then((ref) => {
    const injector = ref.injector;
    const careerEl = createCustomElement(CareerComponent, { injector });
    customElements.define('app-career', careerEl);
    const headerEl = createCustomElement(AppHeaderComponent, { injector });
    customElements.define('app-header', headerEl);
    const footerEl = createCustomElement(AppFooterComponent, { injector });
    customElements.define('app-footer', footerEl);
    const notFoundEl = createCustomElement(NotFoundComponent, { injector });
    customElements.define('not-found', notFoundEl);
    const signLanguageEl = createCustomElement(SignLanguageComponent, {
      injector,
    });
    customElements.define('sign-language', signLanguageEl);
    const internalError = createCustomElement(InternalErrorComponent, {
      injector,
    });
    customElements.define('internal-error', internalError);
  })
  .catch((err) => console.error(err));
